import { useQueryClient } from "@tanstack/react-query"
import { useEffect, useState } from "react"

import { ListItemStack } from "@molecules"
import GenericForm from "@molecules/Form/GenericForm/GenericForm"

import { Settings } from "@templates/index"

import { InventoryNotificationTopics } from "@pages/Settings/SettingsNotifications/SettingsNotification.types"
import {
    notificationPreferenceQueryKey,
    useNotificationPreferencesQuery,
} from "@pages/Settings/SettingsNotifications/SettingsNotifications.store"
import NotificationProperty from "@pages/Settings/SettingsNotifications/components/NotificationProperty/NotificationProperty"

import { NOTIFICATION_ENDPOINTS } from "@endpoints/notification"

export default function InventoryNotificationsForm() {
    const [shouldSetDefaultFormData, setShouldSetDefaultFormData] = useState<boolean>(false)

    const { topicPreference: inventoryNotificationPreference, isLoading: isLoadingData } =
        useNotificationPreferencesQuery<InventoryNotificationTopics>("inventory")

    const queryClient = useQueryClient()

    useEffect(() => {
        if (!isLoadingData && !!inventoryNotificationPreference) {
            setShouldSetDefaultFormData(true)
        }
    }, [isLoadingData])

    const onMutationSuccess = () => {
        void queryClient.invalidateQueries({ queryKey: notificationPreferenceQueryKey })
    }

    const onAfterFormValuesSet = () => {
        setShouldSetDefaultFormData(false)
    }

    return (
        <GenericForm<InventoryNotificationTopics, InventoryNotificationTopics, Error, InventoryNotificationTopics>
            formConfig={{
                defaultValues: undefined,
            }}
            mutationConfig={{
                genericErrorMessage: "Could not update notification preference",
                genericSuccessMessage: "Notification preference updated",
                method: "PATCH",
                endpoint: NOTIFICATION_ENDPOINTS.UPDATE_NOTIFICATION_PREFERENCES,
            }}
            onMutationSuccess={onMutationSuccess}
            formValues={shouldSetDefaultFormData ? inventoryNotificationPreference : undefined}
            onAfterFormValuesSet={onAfterFormValuesSet}
            isAutoSave={true}
        >
            {() => {
                return (
                    <Settings.NotificationConfigPage.Wrapper>
                        <ListItemStack>
                            <NotificationProperty<InventoryNotificationTopics>
                                label="Low inventory digest"
                                supportText="Get a daily summary of all parts that have low or depleted inventory."
                                emailCheckboxName="enable_inventory_notification_low_inventory_email"
                                smsCheckboxName="enable_inventory_notification_low_inventory_sms"
                                isLoading={isLoadingData}
                            />
                        </ListItemStack>
                    </Settings.NotificationConfigPage.Wrapper>
                )
            }}
        </GenericForm>
    )
}
